import React, { useReducer, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig";
import {
  detailsReducer,
  memberDetailsInitialState,
} from "./reducers/detailsReducer";
import { Card, Col, Row } from "react-bootstrap";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import PollSubmissionQuestionsListing from "./partials/details/PollSubmissionQuestionsListing";


const PollSubmissionView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(
    detailsReducer,
    memberDetailsInitialState
  );
  let { pollId, id } = useParams();

  let breadcrumbs = {
    pollListing: {
      label: "Polls",
      url: `/polls`,
    },
    pollDetails: {
      label: "Poll Details",
      url: `/polls/${pollId}`,
    },
    pollSubmissionListing: {
      label: 'Submissions',
      url: `/poll-submissions/${pollId}`
    },
    pollSubmissionDetails: {
      label: 'Submission Details',
    },
  };
  const loadItem = async () => {
    if (id) {
      detailsDispatch({
        type: "FETCH_REQUEST",
      });
      try {
        const res = await axios.get(`${moduleConfig.url}/details/${id}/${pollId}`); //
        detailsDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
      } catch (error) {
        detailsDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([
      breadcrumbs.pollListing,
      breadcrumbs.pollDetails,
      breadcrumbs.pollSubmissionListing,
      breadcrumbs.pollSubmissionDetails,
    ]);
  }, [id]);



  return (
    <DashboardLayout>
      {detailsState.isFetching && <OverlayLoading />}
      {detailsState.data.member && !detailsState.isFetching && (
        <>
          {detailsState.hasError ? (
            <BlockErrorMessage error={detailsState.error} />
          ) : (
            <>
              {detailsState.data.member && (
                <>
                  <ModuleHeader
                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                    moduleUrl={moduleConfig.url}
                  ></ModuleHeader>

                  <Row>

                    <Card className="item  mb-2">
                      <Card.Header className="ps-1 pe-2 py-0">
                        <Card.Title className="m-0 p-0 ">
                          <div className="d-flex ImageSectionSpacing">
                            <div className="d-flex flex-column ms-1">
                              <span className="m-0 text-bold memberName">
                                {detailsState.data.member.firstName + ' ' + detailsState.data.member.lastName}
                              </span>
                              <span className="font-italic font-small font-weight-normal text-success fs-8  ">
                                <span className="membershipId">
                                  {detailsState.data.member.email}
                                </span>
                              </span>
                            </div>
                          </div>
                        </Card.Title>
                      </Card.Header>
                    </Card>
                  </Row>


                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <PollSubmissionQuestionsListing submissions={detailsState.data.submissions} />
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default PollSubmissionView;
